import React, { Component } from 'react';
import { Form, reduxForm } from 'redux-form';
import Button from '../../../../components/Button';
import { FormField } from '../../../../components/CustomForm';
import PaddingBox from '../../../../components/PaddingBox';
import CheckboxAdapter from '../../../../components/adapters/form/Checkbox';
import { NumberTextboxAdapter } from '../../../../components/adapters/form/NumberTextboxAdapter';
import { codes } from '../../../../data/translations';
import { length, required } from '../../../../utils/formValidators';
import { numericality } from '../../../../utils/formValidators';
import { FORM_REGISTER_PASSWORD_NAME } from '../../consts';
import AuthenticationActionButton from '../AuthenticationActionButton';
import classes from './styles/index.module.scss';

@reduxForm({
	form: FORM_REGISTER_PASSWORD_NAME,
	touchOnBlur: false,
})
export class AuthenticationCheckSMSPinCodeForm extends Component {
	render() {
		const {
			handleSubmit,
			handleResendPinCode,
			resendOneTimePinCode,
			translate,
			canResendSms,
			formattedTime,
			is2FA,
			// resendAvailableAt,
		} = this.props;
		//TODO:: vlabinskyy. Rework span onClick to Link.

		return (
			<Form onSubmit={handleSubmit}>
				<FormField
					component={NumberTextboxAdapter}
					name='pinCode'
					validate={[required(), length({ max: 6 }), numericality()]}
					controlProps={{ isRequired: true }}
					componentProps={{ autoFocus: true, pinCodeMode: true }}
				/>
				{is2FA && (
					<PaddingBox topTiny>
						<FormField
							component={CheckboxAdapter}
							name='isPersistent'
							controlProps={{ position: 'right', inline: true }}
							componentProps={{
								label: translate(codes.user.rememberThisComputerForNDays, [30]),
							}}
						/>
					</PaddingBox>
				)}
				<PaddingBox topTiny>
					<AuthenticationActionButton onClick={resendOneTimePinCode}>
						{canResendSms ? (
							<span
								onClick={handleResendPinCode}
								className={classes.resendOneTimePinCode}
							>
								{translate(codes.user.resendOneTimePinCode)}
							</span>
						) : (
							<span className={classes.resendOneTimePinCode}>
								{translate(codes.user.resendOneTimePinCodeIn, [''])} <span>{formattedTime}</span>
							</span>
						)}
					</AuthenticationActionButton>
				</PaddingBox>
				<PaddingBox topSmall>
					<Button
						type='submit'
						primary
						block
						size='small'
					>
						{translate(codes.user.verify)}
					</Button>
				</PaddingBox>
			</Form>
		);
	}
}
